import React from 'react';

import { useSearchParams } from '../../../hooks/useSearchParams';
import { AddPerpetualMass } from '../AddPerpetualMass/AddPerpetualMass';
import {
  QUERY_PARAM_KEYS,
  QUERY_PARAM_VALUES,
} from '../../../constants/massOfferings/queryParamKeys';
import { AfterTransaction } from '../../MassOfferings';

export const PerpetualMassesContent = () => {
  const urlSearchParams = useSearchParams();

  const isFromTransaction =
    urlSearchParams.get(QUERY_PARAM_KEYS.source) === QUERY_PARAM_VALUES.TRANSACTION;

  return isFromTransaction ? <AfterTransaction /> : <AddPerpetualMass />;
};

PerpetualMassesContent.propTypes = {};
